



































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import getClientId from '@/utils/getClientId'
import { updateConnection } from '@/utils/api/connection'
import { MqttClient } from 'mqtt'
import { Getter } from 'vuex-class'

@Component
export default class ConnectionInfo extends Vue {
  @Prop({ required: true }) public connection!: ConnectionModel
  @Prop({ required: true }) public btnLoading!: boolean
  @Prop({ required: true }) public client!: Pick<MqttClient, 'connected'>
  @Prop({ required: true }) public titleName!: string

  @Getter('allConnections') private allConnections!: ConnectionModel[] | []

  private oldName = ''

  @Watch('titleName', { immediate: true, deep: true })
  private handleNameChange(titleName: string) {
    this.oldName = titleName
  }

  // Return the status of client connection
  get isClientConnected() {
    return this.client.connected
  }

  get rules() {
    return {
      name: [
        { required: true, message: this.$t('common.inputRequired') },
        { validator: this.validateName, trigger: 'blur' },
      ],
    }
  }

  get vueForm(): VueForm {
    return this.$refs.form as VueForm
  }

  private async validateName(rule: FormRule, name: string, callBack: NameCallBack) {
    for (const oneConnection of this.allConnections) {
      if (name !== this.oldName && oneConnection.name === name) {
        callBack(this.$tc('connections.duplicateName'))
      }
    }
  }

  private async connect(): Promise<void> {
    this.vueForm.validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }
      const res: ConnectionModel | null = await updateConnection(this.connection.id as string, this.connection)
      if (res) {
        this.$emit('handleConnect', this.connection)
      }
    })
  }

  private disconnect() {
    this.vueForm.validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }
      this.$emit('handleDisconnect', this.connection)
    })
  }

  private cancel() {
    this.$emit('handleCancel', this.connection)
  }

  private refreshClientId() {
    // when the client connected, we should disable this icon event
    if (this.isClientConnected) {
      return
    }
    this.connection.clientId = getClientId()
  }
}
